import { render, staticRenderFns } from "./foot-box.vue?vue&type=template&id=4b6534bb&scoped=true&"
var script = {}
import style0 from "./foot-box.vue?vue&type=style&index=0&id=4b6534bb&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6534bb",
  null
  
)

export default component.exports